import { render, staticRenderFns } from "./SettingsHolders.vue?vue&type=template&id=648e1d97&scoped=true"
import script from "./SettingsHolders.vue?vue&type=script&lang=js"
export * from "./SettingsHolders.vue?vue&type=script&lang=js"
import style0 from "./SettingsHolders.vue?vue&type=style&index=0&id=648e1d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e1d97",
  null
  
)

export default component.exports